import * as React from "react";
import { SelectedChoices } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
const SelectedTypeContainer = ({ urls, store, type, onClick }) => {
  const { getLabel } = useIntl();
  const choices = React.useMemo(() => {
    return {
      type: {
        name: type.name,
        action: getLabel("appointments.component.selectedChoices.change"),
        onClick: () => {
          onClick?.();
          window.location.assign(`${urls.bookAppointment}/what?storeId=${store.globalStoreId}`);
        }
      }
    };
  }, [getLabel, urls, store, type]);
  return /* @__PURE__ */ React.createElement(SelectedChoices, { choices });
};
export {
  SelectedTypeContainer,
  SelectedTypeContainer as default
};
//# sourceMappingURL=SelectedTypeContainer.js.map
